import { Skull, HeartHandshake, HeartCrack, TrendingUp } from 'lucide-react';
import { firstName } from '../../lib/play';

export default function MyPlayCard({ me, total }) {
  const row = me?.row;
  if (!row) return null;
  const winPct = row.matches ? Math.round(100 * row.wins / row.matches) : 0;
  return (
    <div className="rounded-2xl border bg-card p-4" data-testid="my-play-card">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-sm font-bold uppercase tracking-[0.16em]">My card</h3>
        <span className="text-xs text-muted-foreground">#{row.rank} of {total}</span>
      </div>
      <div className="grid grid-cols-4 gap-2 mt-3 text-center">
        <Stat label="Rating" value={row.rating} />
        <Stat label="Win %" value={`${winPct}%`} />
        <Stat label="Streak" value={row.streak > 0 ? `W${row.streak}` : row.streak < 0 ? `L${-row.streak}` : '—'} />
        <Stat label="Peak" value={row.peak} icon={<TrendingUp className="w-3 h-3" />} />
      </div>
      <div className="mt-3 space-y-1.5 text-xs">
        {me.best_duo && (
          <p className="flex items-center gap-1.5" data-testid="my-best-duo">
            <HeartHandshake className="w-3.5 h-3.5 text-emerald-500" />
            Best duo: <b>{firstName(me.best_duo.name)}</b> <span className="text-muted-foreground">({me.best_duo.wins}-{me.best_duo.losses} together)</span>
          </p>
        )}
        {me.cursed_duo && (
          <p className="flex items-center gap-1.5" data-testid="my-cursed-duo">
            <HeartCrack className="w-3.5 h-3.5 text-rose-400" />
            Cursed duo: <b>{firstName(me.cursed_duo.name)}</b> <span className="text-muted-foreground">({me.cursed_duo.wins}-{me.cursed_duo.losses} together)</span>
          </p>
        )}
        {me.nemesis && (
          <p className="flex items-center gap-1.5" data-testid="my-nemesis">
            <Skull className="w-3.5 h-3.5 text-violet-500" />
            Nemesis: <b>{firstName(me.nemesis.name)}</b> <span className="text-muted-foreground">beat you {me.nemesis.beat_me}×</span>
          </p>
        )}
      </div>
    </div>
  );
}

function Stat({ label, value, icon }) {
  return (
    <div className="rounded-xl bg-muted/50 py-2">
      <p className="font-display font-black tabular-nums text-base inline-flex items-center gap-1">{icon}{value}</p>
      <p className="text-xs uppercase tracking-wider text-muted-foreground">{label}</p>
    </div>
  );
}
